'use client'
import { useMemo, useState } from 'react'
import { Accordion, AccordionPanel, AccordionTitle, AccordionContent } from 'flowbite-react'
import RenderRichTexComponent from '@/components/rich-text-render/richTextRender'
import { AccordionPaneProfile } from '@/payload-types'

interface IProps {
  accordionData?: AccordionPaneProfile
  timeStamps?: {
    value: string 
    mediaId: string
  }[]
}

export default function AccordionProfile({ accordionData = [], timeStamps }: IProps) {
  const items = useMemo(() => (Array.isArray(accordionData) ? accordionData : []), [accordionData])
  const [open, setOpen] = useState<boolean[]>(() => items.map(() => false))
  const allOpen = useMemo(() => open.length > 0 && open.every(Boolean), [open])
  const customAccordionTitleTheme = {
    base: 'flex flex-row-reverse justify-end items-center  w-full py-[11px] md:py-[13px] !border-b !border-b-black !border-t-0 text-xl font-bold	md:text-[25px]',
    flush: {
      off: '',
      on: '',
    },
    open: {
      off: '',
      on: '',
    },
  }
  const customAccordionContentTheme = {
    base: ' w-full',
  }
  const toggleOne = (i: number) =>
    setOpen(prev => prev.map((v, idx) => (idx === i ? !v : v)))

  const toggleAll = () =>
    setOpen(prev => prev.map(() => !allOpen))

  if(items.length === 0) return <></>
  
  return (
    <div className="pt-2">
      <button onClick={toggleAll} className="mb-3 border px-3 py-1 rounded">
        {allOpen ? 'Collapse all' : 'Expand all'}
      </button>

      <Accordion flush={true} className="border-b-white" collapseAll={!allOpen}>
        {items.map((item, i) => (
          <AccordionPanel key={item.id ?? i} isOpen={open[i]}>
            <AccordionTitle 
              onClick={() => toggleOne(i)} 
              theme={customAccordionTitleTheme} 
              className={`${open[i] ? 'accordion-open' : 'accordion-close'}`}
            >
              <div className="ml-1 text-start text-xl">{item.header}</div>
            </AccordionTitle>

            {/* We control the visibility with our own state */}
            <AccordionContent className={open[i] ? 'block pt-3' : 'hidden'} theme={customAccordionContentTheme}>
              {item.richText && (
                <RenderRichTexComponent richTextField={item.richText} timeStamps={timeStamps} />
              )}
            </AccordionContent>
          </AccordionPanel>
        ))}
      </Accordion>
    </div>
  )
}
